import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
import { partnerApi } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { getContentType } from "../../../features/kyc/kyc_doc_upload_POI_manual/actions";
import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { isFromAndroidWebview } from "../../../configs/utils";
let imageFileExtension;
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const previewAction = async (action, _datastore, { setDatastore, network, navigate, instrumentTrack }) => {
    const collateralCategory = action.payload.collateralCategory;
    instrumentTrack("PREVIEW_COLLATERAL_BUTTON_CLICKED", {
        collateralCategory: collateralCategory
    });
    await setDatastore(ROUTE.COLLATERAL_DOWNLOAD_INFO, "collateralDownloadInfoScreen", {
        previewLoading: true
    });
    let imageNameFromAPI;
    let previewUrl;
    let fileUrlExtension;
    if (imageFileExtension !== undefined && imageFileExtension !== null) {
        fileUrlExtension = imageFileExtension;
    }
    else if (await AsyncStorage.getItem("collateralImageExtension") !== undefined && await AsyncStorage.getItem("collateralImageExtension") !== null) {
        fileUrlExtension = await AsyncStorage.getItem("collateralImageExtension");
    }
    else {
        fileUrlExtension = 'png';
    }
    await network.post(partnerApi.getPreviewUrl, {
        fullName: action.payload.fullName,
        phoneNumber: action.payload.phoneNumber,
        emailId: action.payload.emailId,
        collateralImageFileName: action.payload.collateralImageFileName,
        partnerAccountId: action.payload.partnerAccountId
    }, {
        headers: await getAppHeader(),
    }).then(async (response) => {
        if (response.status === 200) {
            await setDatastore(ROUTE.COLLATERAL_DOWNLOAD_INFO, "collateralDownloadInfoScreen", {
                previewLoading: false
            });
            imageNameFromAPI = response.data.generatedCollateralS3Key;
            const dotIndex = imageNameFromAPI.indexOf('.');
            const resultString = imageNameFromAPI.slice(0, dotIndex);
            previewUrl = response.data.generatedCollateralPresignedUrl;
            await navigate(ROUTE.PREVIEW_COLLATERAL, {
                previewUrl: previewUrl,
                imageNameFromAPI: resultString,
                imageFileExtension: fileUrlExtension,
                collateralCategory: collateralCategory
            });
        }
    });
};
export const uploadImageToS3 = async (action, _datastore, { network, setDatastore }) => {
    await setDatastore(ROUTE.COLLATERAL_DOWNLOAD_INFO, "collateralDownloadInfoScreen", {
        uploadingImagetoS3: true,
        uploadedImagetoS3: false,
        callSamePropAgain: Math.random()
    });
    const imageBody = action.payload.imageBody;
    const accountId = (await SharedPropsService.getUser()).linkedPartnerAccounts[0].accountId;
    const preSignedURLData = await network.get(`${partnerApi.getPartnerLogoUrl}${accountId}`, { headers: await getAppHeader() });
    const preSignedUrl = preSignedURLData.data.preSignedUrl;
    if (imageBody) {
        // eslint-disable-next-line no-prototype-builtins
        imageFileExtension = Platform.OS === 'web'
            ? imageBody.name.split('.').pop() :
            imageBody.hasOwnProperty('name')
                ? imageBody.name.split('.').pop()
                : imageBody.fileName.split('.').pop();
        await AsyncStorage.setItem("collateralImageExtension", imageFileExtension);
    }
    await network.put(preSignedUrl, imageBody, {
        headers: { 'Content-Type': getContentType(imageFileExtension) },
    }).then(response => {
        if (response.status === 200) {
            setDatastore(ROUTE.COLLATERAL_DOWNLOAD_INFO, "collateralDownloadInfoScreen", {
                uploadingImagetoS3: false,
                uploadedImagetoS3: true,
                callSamePropAgain: Math.random()
            });
        }
    });
};
export const downloadCollateral = async (action, _datastore, { network, setDatastore, instrumentTrack }) => {
    const collateralCategory = action.payload.collateralCategory;
    instrumentTrack("DOWNLOAD_COLLATERAL_BUTTON_CLICKED", {
        collateral_category: collateralCategory
    });
    await setDatastore(ROUTE.COLLATERAL_DOWNLOAD_INFO, "collateralDownloadInfoScreen", {
        downloadLoading: true
    });
    let imageNameFromAPI;
    let preSignedURL;
    let fileUrlExtension;
    if (imageFileExtension !== undefined && imageFileExtension !== null) {
        fileUrlExtension = imageFileExtension;
    }
    else if (await AsyncStorage.getItem("collateralImageExtension") !== undefined && await AsyncStorage.getItem("collateralImageExtension") !== null) {
        fileUrlExtension = await AsyncStorage.getItem("collateralImageExtension");
    }
    else {
        fileUrlExtension = 'png';
    }
    await network.post(partnerApi.getPreviewUrl, {
        fullName: action.payload.fullName,
        phoneNumber: action.payload.phoneNumber,
        emailId: action.payload.emailId,
        collateralImageFileName: action.payload.collateralImageFileName,
        partnerAccountId: action.payload.partnerAccountId
    }, {
        headers: await getAppHeader(),
    }).then(async (response) => {
        if (response.status === 200) {
            await setDatastore(ROUTE.COLLATERAL_DOWNLOAD_INFO, "collateralDownloadInfoScreen", {
                downloadLoading: false
            });
            imageNameFromAPI = response.data.generatedCollateralS3Key;
            const dotIndex = imageNameFromAPI.indexOf('.');
            const resultString = imageNameFromAPI.slice(0, dotIndex);
            console.log(resultString);
            preSignedURL = response.data.generatedCollateralPresignedUrl;
            fetch(preSignedURL)
                .then((response) => response.blob())
                .then((blob) => {
                if (isFromAndroidWebview()) {
                    window.open(preSignedURL);
                }
                else {
                    // Create a temporary anchor element to initiate the download
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${resultString}.${fileUrlExtension}`;
                    document.body.appendChild(a);
                    a.click();
                    URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }
            })
                .catch((error) => {
                console.warn('Error download file: ', error);
            });
        }
    });
};
